<template>
  <div class="sc-card-container">
    <div class="sc-card-slot sc-card-title-slot">
      <slot name="title"></slot>
    </div>
    <div class="sc-card-slot">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScCard'
}
</script>

<style lang="scss" scoped>
.sc-card-container {
  display: inline-block;
  border: $sc-card-border;
}
.sc-card-slot {
  margin: $sc-card-margin;
  text-align: left;
}
.sc-card-title-slot {
  color: $sc-card-title-color;
  font-weight: $sc-card-title-font-weight;
}
</style>
